module.exports = require("@mui/material/CardContent");